import { render, staticRenderFns } from "./RfidVitana.vue?vue&type=template&id=707310e0"
import script from "./RfidVitana.vue?vue&type=script&lang=js"
export * from "./RfidVitana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports